@if (loggedIn$ | async) {
    @let settings = settings$ | async;

    @if (settings) {
        <app-toolbar [languages]="languages$ | async"
                     [currentLang]="currentLang$ | async"
                     (burgerMenuClick)="openBurgerMenu()"
                     (switchLang)="onSwitchLang($event)">

            <app-navbar class="px-sm-3 py-4">
                @for (item of navItemList | navItemAccess: settings; track $index) {
                    @if (item.path) {
                        <li app-nav-item [titleText]="item.title | translate"
                            [link]="item.path" role="presentation">
                            {{ item.title | translate }}
                        </li>
                    }
                }
            </app-navbar>

            @let person = person$ | async;
            @if (person) {
                <app-user-menu class="me-10 d-block"
                               [person]="person" />
            }
        </app-toolbar>
    }

} @else {
    <app-toolbar class="toolbar--noAuth"
                 [languages]="languages$ | async"
                 [currentLang]="currentLang$ | async"
                 (switchLang)="onSwitchLang($event)"
                 [hideLogo]="true"
                 [hideBurgerMenu]="true" />
}

